module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-main', {
    staticClass: "login-background"
  }, [_c('v-container', {
    staticStyle: {
      "margin-bottom": "100px"
    },
    attrs: {
      "container--fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md4": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-12 login-card"
  }, [_c('v-toolbar', {
    staticClass: "brand-login-toolbar",
    attrs: {
      "height": "172",
      "tabs": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "login-logo-wrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoPrimary,
      "alt": "Kobe"
    }
  })]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tabs', {
    staticClass: "login-tabs",
    attrs: {
      "slot": "extension",
      "centered": "",
      "slider-color": "#3F3FFF",
      "grow": ""
    },
    slot: "extension",
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tab', {
    staticClass: "login-tab",
    attrs: {
      "href": "#login-tab"
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('v-tab', {
    staticClass: "login-tab",
    attrs: {
      "href": "#signup-tab"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab()
      }
    }
  }, [_vm._v("Sign Up")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "login-card-text"
  }, [_c('v-tabs-items', {
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tab-item', {
    staticClass: "text-center",
    attrs: {
      "value": "login-tab"
    }
  }, [_c('v-row', {
    staticClass: "pt-5",
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "sm": "12",
      "lg": "8"
    }
  }, [_c('v-btn', {
    staticClass: "white--text ma-1 mb-2",
    attrs: {
      "width": "260px",
      "color": "secondary"
    },
    on: {
      "click": _vm.instagramLogin
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "color": "white",
      "medium": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v("Login with instagram\n                      ")], 1), _vm._v(" "), _c('div', {
    staticClass: "g-login-container"
  }, [_c('div', {
    ref: "googleLoginBtn"
  })])], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "8"
    }
  }, [_c('v-form', [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.emailErrors,
      "prepend-icon": "person",
      "name": "email",
      "label": "Email",
      "type": "text",
      "width": "260px"
    },
    on: {
      "blur": function($event) {
        return _vm.$v.email.$touch()
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
      },
      "input": _vm.removeSpaces,
      "paste": _vm.preventPasteSpaces
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "error-messages": _vm.passwordErrors,
      "id": "password",
      "prepend-icon": "lock",
      "name": "password",
      "label": "Password",
      "type": "password",
      "width": "260px"
    },
    on: {
      "input": function($event) {
        return _vm.$v.password.$touch()
      },
      "blur": function($event) {
        return _vm.$v.password.$touch()
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.checkCreds()
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "color": "secondary",
      "rounded": "",
      "width": "260px"
    },
    on: {
      "click": function($event) {
        return _vm.checkCreds()
      }
    }
  }, [_vm._v("Login ")])], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "to": "/forgot-password",
      "color": "secondary"
    }
  }, [_vm._v("Forgot password?")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.showRegisterTab()
      }
    }
  }, [_vm._v("Create New Account")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_vm._v("\n                    By logging in, you confirm that you have read the\n                    "), _c('a', {
    attrs: {
      "href": "https://www.getkobe.com/influencer-terms-use-agreement/",
      "target": "_blank"
    }
  }, [_vm._v("terms and conditions")]), _vm._v(" , that you understand them and that you agree to be bound by them.\n                  ")])], 1), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "value": "signup-tab"
    }
  }, [_c('div', {
    staticClass: "text-center",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('v-btn', {
    staticClass: "white--text ma-1 mb-2",
    attrs: {
      "width": "280px",
      "color": "secondary"
    },
    on: {
      "click": _vm.doFacebookLogin
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "medium": ""
    }
  }, [_vm._v("mdi-facebook")]), _vm._v("Continue with Facebook\n                    ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text ma-1 mb-2",
    attrs: {
      "width": "280px",
      "color": "secondary"
    },
    on: {
      "click": _vm.instagramLogin
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "color": "white",
      "medium": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v("Signup with instagram\n                    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "g-login-container"
  }, [_c('div', {
    ref: "googleSignUpBtn"
  })]), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center msg-box"
  }, [_c('p', [_vm._v("\n                      If you require further technical assistance, please refer to this platform "), _c('a', {
    attrs: {
      "href": "https://drive.google.com/file/d/1aBHRO61bi3Q0XRvDYK-b8VnImvqCBoqz/view",
      "target": "_blank"
    }
  }, [_vm._v("guide")]), _vm._v(" or reach out to us at "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://mail.google.com/mail/?view=cm&fs=1&to=creator@getkobe.com",
      "target": "_blank"
    }
  }, [_vm._v("creator@getkobe.com")])])])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.showUpdateDialog),
      callback: function($$v) {
        _vm.showUpdateDialog = $$v
      },
      expression: "showUpdateDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n            New Updates to Kobe's IMS\n          ")]), _vm._v(" "), _c('v-card-text', [_c('p', [_c('br'), _vm._v("\n            Kobe's tech team is always on the ball to keep our platform safe, secure, and user-friendly. Unfortunately, sometimes we may need to make changes too.\n            Unbeknownst to many, in January 2018, Facebook publicly announced its plans to shut down the Instagram Legacy API platform through a sequenced approach. What this means for us in human language is that we will need to change your login methods very soon. "), _c('br'), _vm._v("\n            And since it's a mandatory change, we will be making a compulsory switch from Instagram Login to Facebook Login method starting from 29th June.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n            Do take note of the following:\n            "), _c('ol', [_c('li', [_vm._v("If you are using Email and Password to login to app.getkobe.com, no actions are required. (mainly for our clients)")]), _vm._v(" "), _c('li', [_vm._v("If you are using Instagram to login to app.getkobe.com, you will need to re-login with the new Facebook login instead. (Your account will be automatically associated if your Facebook and Instagram account is linked) please ensure your profile switched to either a creator/business profile.")])])]), _vm._v(" "), _c('p', [_vm._v("\n            For some reasons, if you're stuck, reply to this email and we will help you with the setup! We're here to help make this switch as seamless as possible.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n            Feel free to drop us a message if you have any problems/questions and we hope to see you in our campaign inboxes soon!\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n            Love, "), _c('br'), _vm._v("\n            Kobe Fam.\n            ")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showUpdateDialog = false
      }
    }
  }, [_vm._v("\n              Close\n            ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-footer', {
    attrs: {
      "dark": "",
      "color": "#1A1A1A"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "white--text": "",
      "text-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "white--text text-center"
  }, [_c('u', [_vm._v("Singapore")]), _vm._v(" "), _c('br'), _vm._v("Contact:\n          "), _c('a', {
    attrs: {
      "href": "tel:+6562555662"
    }
  }, [_vm._v("6255 5662")]), _vm._v(" /\n          "), _c('a', {
    attrs: {
      "href": "mailto:creator@getkobe.com"
    }
  }, [_vm._v("creator@getkobe.com")]), _vm._v(" "), _c('br'), _vm._v("51 Goldhill Plaza #14-01 Singapore 308900\n        ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "white--text text-center"
  }, [_c('br'), _vm._v("Website\n          "), _c('a', {
    attrs: {
      "href": "https://getkobe.com/website-terms-use"
    }
  }, [_vm._v("Terms of Use")]), _vm._v(" and\n          "), _c('a', {
    attrs: {
      "href": "https://getkobe.com/website-privacy-policy"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(".\n          "), _c('br'), _vm._v("\n          All Rights Reserved © 2016-" + _vm._s(_vm.year) + " Kobe Global Technologies Pte Ltd\n        ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "white--text text-center mb-0 pt-2"
  }, [_vm._v("\n          Patent: "), _c('a', {
    attrs: {
      "href": "https://patentscope.wipo.int/search/en/detail.jsf?docId=SG235183686&_cid=P20-KEI88S-46965-1",
      "target": "_blank"
    }
  }, [_vm._v(" KOBE 11201807777W ℗ ")])])])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.loading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "#A3FF12",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.loading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "g_id_onload",
      "data-client_id": _vm.gSigninConfig.CLIENT_ID,
      "data-login_uri": _vm.currentDomain,
      "data-auto_prompt": "false"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f87b417"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 2224
// module chunks = 0